// SPDX-License-Identifier: AGPL-3.0-or-later
// parley: the browser tests proxy the gateway socket to read its frames and
// therefore need the transport uncompressed on both ends. Nothing in the
// product writes this key. The production build deletes window.localStorage,
// so this reads the captured backend. Upstream always uses zstd-stream.

import type {CompressionType} from '@app/features/gateway/transport/GatewayCompression';
import {getProtectedLocalStorage} from '@app/features/platform/state/ProtectedWebStorage';

export function getPreferredCompression(): CompressionType {
	try {
		if (getProtectedLocalStorage()?.getItem('parley:gatewayCompression') === 'none') return 'none';
	} catch {
		// Storage can be unavailable (private mode); compression stays on.
	}
	return 'zstd-stream';
}
